import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="nav-container">
      <div className="nav-header">
        <div className="nav-logo">
          <NavLink to="/" className="logo">Timepass Game</NavLink>
        </div>
        <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          ☰
        </button>
        <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
          <li><NavLink exact to="/" className="nav-page">Games</NavLink></li>
          <li><NavLink to="/spin-wheels" className="nav-page">Spin Wheels</NavLink></li>
          <li><NavLink to="/tools" className="nav-page">Tools</NavLink></li>
          <li><NavLink to="/help" className="nav-page">Help</NavLink></li>
          <li><NavLink to="/about" className="nav-page">About</NavLink></li>
          <li><NavLink to="/contact" className="nav-page">Contact</NavLink></li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
